import { focusTrap } from './focus-trap'

export default function (config) {
  return new focusTrap(config)
}
